import React from 'react';
import { Grid, TextField, Button, DialogContent, MenuItem } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import DraggableDialog from '../../ui/draggableDialog';
import { ValidRoleService } from '../../../service/validDataService';
import { toast } from 'react-toastify';

export default function EditRoleForm({ open, onClose, onRecordEdited, role }) {
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { code, message, data } = await ValidRoleService.update(values);
      setSubmitting(false);
      if (code === 0) {
        toast.success(message || 'Role updated');
        onClose();
        onRecordEdited(data);
      } else {
        toast.error(message || 'Failed to update role');
      }
    } catch (e) {
      setSubmitting(false);
      toast.error('Failed to update role');
    }
  };

  return (
    <DraggableDialog title={'Edit Role'} onClose={onClose} open={open} width={'sm'}>
      <DialogContent>
        <Formik initialValues={role || { id: null, name: '', description: '', status: 'active' }} enableReinitialize onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field as={TextField} name="name" label="Name" size="small" required fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Field as={TextField} name="description" label="Description" size="small" fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Field as={TextField} name="status" label="Status" size="small" select fullWidth>
                    <MenuItem value={'active'}>Active</MenuItem>
                    <MenuItem value={'inactive'}>Inactive</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" disabled={isSubmitting}>Update</Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </DraggableDialog>
  );
}
